"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HoursOfOperationDaily;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function HoursOfOperationDaily(props) {
  var hourGroups = props.hourGroups,
      isHorizontal = props.isHorizontal,
      animated = props.animated,
      celled = props.celled,
      inlineHours = props.inlineHours;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List, {
    horizontal: isHorizontal,
    animated: animated,
    celled: celled,
    relaxed: true
  }, hourGroups.map(function (hourGroup) {
    var dayLabel = hourGroup.dayLabel,
        hoursValue = hourGroup.hoursValue;
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, {
      key: dayLabel
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Header, {
      as: "h5"
    }, dayLabel, inlineHours && ": ".concat(hoursValue.join(' | '))), !inlineHours && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Description, null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "unstyled-list"
    }, hoursValue.map(function (hour) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: hour
      }, hour);
    })))));
  }));
}